import React from 'react';
import { AdminHappyHour } from './AdminHappyHour';

export default function AdminHappyHourPage() {
  return (
    <div className="space-y-5" data-testid="admin-happy-hour-page">
      <header>
        <h1 className="font-serif text-[30px] leading-tight">Happy Hour</h1>
        <p className="text-[12.5px] text-[#5a5a5a] mt-1">Solicitudes de descuento temporal de los TMs · aprobación, ciclo automático y cierre con foto de monolito.</p>
      </header>
      <AdminHappyHour/>
    </div>
  );
}
